// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { qualityGuidelinesService } from './service';
import * as qualityGuidelinesActions from './actions';
import * as types from './actionTypes';

function* qualityGuidelinesSaga() {
  const res = yield call(qualityGuidelinesService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title, gallery_image_picker } = result;
    let { paragraphs } = result;
    paragraphs = paragraphs.map((el) => {
      return {
        title: el.title,
        text: el.text,
      };
    });
    const images = gallery_image_picker.map((el) => {
      return {
        image: el.image.meta.download_url,
        description: el.description,
      };
    });
    yield put(qualityGuidelinesActions.requestPageDataSuccess({
      title,
      paragraphs,
      images,
    }));
  }
}

const qualityGuidelinesSagas = [
  takeEvery(types.QG_REQUEST_PAGE_DATA, qualityGuidelinesSaga),
];

export default qualityGuidelinesSagas;
